import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Route User Cell Renderer
 * Displays route and user information using UserRouteDisplayComponent
 */
@Component({
  selector: 'app-route-user-cell-renderer',
  standalone: true,
  imports: [CommonModule, UserRouteDisplayComponent],
  template: `
    <div class="table-text-m leading-tight" *ngIf="hasData; else noData">
      <app-user-route-display
        [routeData]="routeData"
        [userData]="userData"
        [responsibleData]="responsibleData"
        [displayMode]="'detailed'"
        [showRouteCode]="true"
        [showUser]="true"
        [showResponsible]="true">
      </app-user-route-display>
    </div>
    <ng-template #noData>
      <span>-</span>
    </ng-template>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class RouteUserCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get hasData(): boolean {
    const data = this.params?.data;
    return !!(data?.subRoute || data?.user);
  }

  get routeData() {
    const element = this.params?.data;
    return {
      routeName: element?.subRoute?.name ?? '-',
      externalKeys: {
        code: element?.subRoute?.externalKeys?.code ?? element?.subRoute?.model ?? '-'
      }
    };
  }

  get userData() {
    const element = this.params?.data;
    return {
      name: element?.user ?? '-'
    };
  }

  get responsibleData() {
    const element = this.params?.data;
    return {
      name: element?.responsibleBusinessPartner?.name ?? element?.subRoute?.responsibleName ?? '-',
      personNumber: element?.responsibleBusinessPartner?.personNumber ?? '-',
      externalKeys: {
        code: element?.responsibleBusinessPartner?.externalKeys?.code ?? element?.subRoute?.responsibleCode ?? '-'
      }
    };
  }
}
